import apiService from '../../services/api-service';

import {
    GETCONTENT_REQUESTED,
    GETCONTENT_COMPLETED,
    GETCONTENT_FAILED,
} from './types';

import debug from '../../services/debug';

const getContentAction = async () => async (dispatch, getState) => {
    dispatch({
        type: GETCONTENT_REQUESTED,
    });

    try {
        const el = document.getElementById('reasons-why-app');
        let url = el.getAttribute('data-content-url');
        if (!url) {
            url = '/wp-admin/admin-ajax.php?action=reasonswhy';
        }

        const payload = await apiService.get(url);

        return dispatch({
            type: GETCONTENT_COMPLETED,
            payload,
        });
    } catch (err) {
        debug(err);

        dispatch({
            type: GETCONTENT_FAILED,
            ayload: err,
        });
    }
};

export default getContentAction;
